var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16694_49707)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 15.2021C16.5 15.7544 16.0523 16.2021 15.5 16.2021H1.5C0.947719 16.2021 0.5 15.7544 0.5 15.2021C0.5 14.6499 0.947719 14.2021 1.5 14.2021H15.5C16.0523 14.2021 16.5 14.6498 16.5 15.2021ZM4.95697 5.7452C5.21287 5.7452 5.46881 5.64758 5.66406 5.4523L7.5 3.61636V11.3272C7.5 11.8795 7.94772 12.3272 8.5 12.3272C9.05228 12.3272 9.5 11.8795 9.5 11.3272V3.61636L11.3359 5.4523C11.7265 5.84283 12.3596 5.84283 12.7502 5.4523C13.1407 5.06177 13.1407 4.42861 12.7502 4.03808L9.20709 0.495047C8.81656 0.104516 8.18341 0.104516 7.79287 0.495047L4.24984 4.03808C3.85931 4.42861 3.85931 5.06177 4.24984 5.4523C4.44513 5.64758 4.70103 5.7452 4.95697 5.7452Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16694_49707"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5 0.202148)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.4de47ca624916b1b0d237ca897413cbf.svg";
export { ForwardRef as ReactComponent };